import { ICoreSettings } from '../../types/coreSettings'
import { AppDispatch } from '../../types/store'
import { coreSettingsActions } from '../slices/coreSettingsSlice'

// ============= actions ============ //

export const modifyCoreSettings =
    (payload: { guid: string; data: ICoreSettings }) =>
    (dispatch: AppDispatch) => {
        dispatch(coreSettingsActions.modifyCoreSettings(payload))
    }